import type { ReactNode } from 'react';

import { useAppTranslations } from '@treneo/shared/i18n';
import { ExpandMoreIcon } from '@treneo/shared/icons';
import { Box, Card, CardContent, IconButton, Row, Typography } from '@treneo/shared/ui';

type Props = Readonly<{
  titleKey: string;
  isExpanded: boolean;
  onToggle: () => void;
  disabled?: boolean;
  children: ReactNode;
}>;

export const CollapsibleCard = ({
  titleKey,
  isExpanded,
  onToggle,
  disabled = false,
  children
}: Props) => {
  const { t } = useAppTranslations();

  return (
    <Card>
      <CardContent>
        <Box component='div' onClick={onToggle} sx={{ cursor: 'pointer', userSelect: 'none' }}>
          <Row justifyContent='space-between' alignItems='center'>
            <Typography variant='h6'>{t(titleKey)}</Typography>
            <IconButton
              size='small'
              onClick={e => {
                e.stopPropagation();
                onToggle();
              }}
              disabled={disabled}
              sx={{
                transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s'
              }}
              aria-label={isExpanded ? t('admin.hideHistory') : t('admin.showHistory')}
            >
              <ExpandMoreIcon />
            </IconButton>
          </Row>
        </Box>
        {isExpanded && children}
      </CardContent>
    </Card>
  );
};
